export default __webpack_public_path__ + "static/media/bg-nft.0a540ef9.jpeg";